import { render, staticRenderFns } from "./HonestBusinessman.vue?vue&type=template&id=2cca188f&"
import script from "./HonestBusinessman.vue?vue&type=script&lang=js&"
export * from "./HonestBusinessman.vue?vue&type=script&lang=js&"
import style0 from "./HonestBusinessman.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports